module.exports = __webpack_public_path__ + "img/H1.88cf23dd.png";